jQuery('.gform_fields > .gfield').on('click', function(event) {
    event.stopPropagation();
    jQuery('.gform_fields > .gfield').each(function() {
        var curFiledVal = jQuery(this).find('input,textarea,select').val();
        if (curFiledVal === '') {
            jQuery(this).removeClass('focus');
        }
    });
    if (jQuery(event.target).find('input,textarea,select').val() !== '') {
        jQuery(event.target).closest('.gfield').addClass('focus');
    } else {
        jQuery(event.target).closest('.gfield').removeClass('focus');
    }
});
jQuery('.gform_fields .gfield input, .gform_fields .gfield textarea, .gform_fields .gfield select').bind('keydown', function(e) {
    var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
    if (key === 9) {
        var tabindex = jQuery(this).attr('tabindex');
        tabindex++;
        jQuery('[tabindex=' + tabindex + ']').focus();
        jQuery('.gform_fields > .gfield').each(function() {
            var curFiledVal = jQuery(this).find('input,textarea,select').val();
            if (curFiledVal === '') {
                jQuery(this).removeClass('focus');
                jQuery(this).find('.gfield_select').removeClass('cs-active');
            } else {
                jQuery(this).find('.gfield_select').removeClass('cs-active');
            }

        });
        jQuery('[tabindex=' + tabindex + ']').closest('.gfield').addClass('focus');
        jQuery('[tabindex=' + tabindex + ']').closest('.gfield').find('.gfield_select').addClass('cs-active');
        return false;
    }
});
jQuery('.gform_fields .gfield input, .gform_fields .gfield textarea, .gform_fields .gfield select').keydown(function(e) {
    if (e.shiftKey && e.keyCode === 9) {
        var tabindex = jQuery(this).attr('tabindex');
        tabindex--;
        jQuery('[tabindex=' + tabindex + ']').focus();
        jQuery('.gform_fields > .gfield').each(function() {
            var curFiledVal = jQuery(this).find('input,textarea,select').val();
            if (curFiledVal === '') {
                jQuery(this).removeClass('focus');
                jQuery(this).find('.gfield_select').removeClass('cs-active');
            } else {
                jQuery(this).find('.gfield_select').removeClass('cs-active');
            }
        });
        jQuery('[tabindex=' + tabindex + ']').closest('.gfield').addClass('focus');
        jQuery('[tabindex=' + tabindex + ']').closest('.gfield').find('.gfield_select').addClass('cs-active');
        return false;
    }
});

jQuery(document).click(function() {
    jQuery('.gform_fields > .gfield').each(function() {
        if (jQuery(this).find('input,textarea,select').val() !== '') {
            jQuery(this).addClass('focus');
            jQuery(this).find('.gfield_select').removeClass('cs-active');
        } else {
            jQuery(this).removeClass('focus');
        }
    });
});


jQuery(document).bind('gform_post_render', function() {
    jQuery('.gform_wrapper form, .gform_fields > .gfield input').attr("autocomplete", "off");
    jQuery('.gform_fields > .gfield').each(function() {
        var curFiledVal = jQuery(this).find('input,textarea,select').val();
        if (curFiledVal === '') {
            jQuery(this).removeClass('focus');
            jQuery(this).find('.gfield_select').removeClass('cs-active');
        } else {
            jQuery(this).addClass('focus');
            jQuery(this).find('.gfield_select').removeClass('cs-active');
        }
        if(curFiledVal !='' && jQuery(this).hasClass('select-field')){
            jQuery(this).addClass('val-selected');
        }else{
            jQuery(this).removeClass('val-selected');
        }
    });
    jQuery('.gform_fields > .gfield').on('click', function(event) {
        event.stopPropagation();
        jQuery('.gform_fields > .gfield').each(function() {
            var curFiledVal = jQuery(this).find('input,textarea,select').val();
            if (curFiledVal === '') {
                jQuery(this).removeClass('focus');
            }
        });
        if (jQuery(event.target).find('input,textarea,select').val() !== '') {
            jQuery(event.target).closest('.gfield').addClass('focus');
        } else {
            jQuery(event.target).closest('.gfield').removeClass('focus');
        }
    });
    jQuery('.gform_fields .gfield input, .gform_fields .gfield textarea, .gform_fields .gfield select').bind('keydown', function(e) {
        var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
        if (key === 9) {
            var tabindex = jQuery(this).attr('tabindex');
            tabindex++;
            jQuery('[tabindex=' + tabindex + ']').focus();
            jQuery('.gform_fields > .gfield').each(function() {
                var curFiledVal = jQuery(this).find('input,textarea,select').val();
                if (curFiledVal === '') {
                    jQuery(this).removeClass('focus');
                    jQuery(this).find('.gfield_select').removeClass('cs-active');
                } else {
                    jQuery(this).find('.gfield_select').removeClass('cs-active');
                }
            });
            jQuery('[tabindex=' + tabindex + ']').closest('.gfield').addClass('focus');
            jQuery('[tabindex=' + tabindex + ']').closest('.gfield').find('.gfield_select').addClass('cs-active');
            return false;
        }
    });
    jQuery('.gform_fields .gfield input, .gform_fields .gfield textarea, .gform_fields .gfield select').keydown(function(e) {
        if (e.shiftKey && e.keyCode === 9) {
            var tabindex = jQuery(this).attr('tabindex');
            tabindex--;
            jQuery('[tabindex=' + tabindex + ']').focus();
            jQuery('.gform_fields > .gfield').each(function() {
                var curFiledVal = jQuery(this).find('input,textarea,select').val();
                if (curFiledVal === '') {
                    jQuery(this).removeClass('focus');
                    jQuery(this).find('.gfield_select').removeClass('cs-active');
                } else {
                    jQuery(this).find('.gfield_select').removeClass('cs-active');
                }
            });
            jQuery('[tabindex=' + tabindex + ']').closest('.gfield').addClass('focus');
            jQuery('[tabindex=' + tabindex + ']').closest('.gfield').find('.gfield_select').addClass('cs-active');
            return false;
        }
    });  
});